import { FC } from 'react';
import style from './buttonIconVerticalStyle.module.css';
import { Skeleton } from '@/components/uiParts/Skeleton/Skeleton';

/**
 * ButtonIconVertical の読み込み中プレースホルダ。
 * 実ボタンと同じ CSS モジュールを使い、円形アイコン＋ラベルの形を揃える。
 * （角丸矩形のままだと周囲のボタンと形が違い、そこだけ浮いて見える）
 */
export const ButtonIconVerticalSkeleton: FC = () => (
  <div className={style['button-wrapper']}>
    <Skeleton width="70px" height="70px" radius="50%" />
    <div className={style['label']}>
      <Skeleton width="52px" height="12px" />
    </div>
  </div>
);
